<template>
  <section class="info-screen">
    <slot />
  </section>
</template>

<style scoped>
.info-screen {
  width: 100%;
  max-width: 430px;
  margin-inline: auto;
  padding: 32px;
}
</style>
